import { render } from "./compareFacade.vue?vue&type=template&id=7c6ba542"
import script from "./compareFacade.vue?vue&type=script&lang=js"
export * from "./compareFacade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__